import DigitalMuseum from 'pages/digital-museum/digital-museum';
import Home from './pages/home';
import News from 'pages/news/news';
// import Contact from 'pages/contact';

export const routes = [
  {
    name: 'Trang chủ',
    path: '/',
    element: <Home />
  },
  {
    name: 'Tin tức',
    path: '/tin-tuc',
    element: <News />
  },
  {
    name: 'Thư viện số',
    path: `thu-vien-so`
  },
  {
    name: 'Triển lãm số',
    path: '/trien-lam-so'
  }
  // {
  //   name: 'Bảo tàng số',
  //   path: `bao-tang-so`,
  //   element: <DigitalMuseum />
  // }
  // {
  //   name: 'Liên hệ',
  //   path: '/lien-he',
  //   element: <Contact />
  // }
];

export default routes;
